import { addShippingCostApi } from "./addShippingCostApi";

export const addShippingCostSetData = async (
  lang,
  setMessageResponse,
  cookies,
  payload,
  setSuccessMessage,
  setBtnLoader,
  shipping_id
) => {
  const response = await addShippingCostApi(payload, lang, cookies, shipping_id);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
